import React, { useEffect } from "react";
import ReviewAndSubmit from "../../assets/svg/ReviewAndSubmit.svg";
import CompleteTheForm from "../../assets/svg/CompleteTheForm.svg";
import SignContract from "../../assets/svg/SignContract.svg";

import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import styles from "./SellWelcomeScreen.module.css";
import BenefitCard from "../GetQualified/FinancialPreQualification/BenefitCard";
import config from "../../config";
import { LuArrowUpRight } from "react-icons/lu";

export default function SellWelcomeScreen() {
    const navigate = useNavigate();
    const benefits = [
        {
            title: "Complete the Form",
            description: "Provide essential details about your property, including price, features, and photos.",
            iconSrc: CompleteTheForm,
        },
        {
            title: "Review and Submit",
            description: "Double-check your listing information to ensure accuracy before submitting.",
            iconSrc: ReviewAndSubmit,
        },
        {
            title: "Sign the E-Contract",
            description: "Securely sign the agreement online to complete your listing.",
            iconSrc: SignContract,
        },
    ];
    useEffect(() => {
        document.title = `List Now | ${config.get("COMPANY_NAME")}`;
    }, []);
    return (
        <div className={`${styles.container}  tw-bg-background_color`}>
            <main className={`${styles.mainContent} tw-overflow-y-auto`}>
                {/* <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/0bbafeda80572fe08294a1d09a0d5e5d56d369a649532326f010c638f91f9cd4?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
            alt=""
            className={styles.backgroundImage}
        /> */}
                <Header title="Welcome to List Now" />
                <div></div>
                <section className={`${styles.contentWrapper} tw-px-3 tw-mt-10`}>
                    <div className={`${styles.titleSection}`}>
                        <h2 className={styles.mainTitle}>Why List Your Property?</h2>
                        <p className={`${styles.subtitle}  tw-mt-2`}>Here’s a simple guide to get your property listed quickly:</p>
                    </div>
                    <div className={`${styles.benefitsContainer}`}>
                        {benefits.map((benefit, index) => (
                            <BenefitCard key={index} {...benefit} />
                        ))}
                    </div>
                    <div className={styles.ctaWrapper}>
                        <button onClick={() => navigate("/list-property")} className={`${styles.ctaButton} tw-bg-primary hover:tw-bg-primary_hover tw-text-white`}>
                            <div className={styles.ctaContent}>
                                <p className={`tw-text-[24px] tw-font-normal tw-text-white`}>Get Started</p>
                                <LuArrowUpRight size={27} color="white" />
                            </div>
                        </button>
                    </div>
                </section>
                <footer className={styles.footerWrapper}>
                    <p className={styles.footerText}>Your information is safe and secure with us.</p>
                    <a onClick={() => navigate("/privacy-policy")} className={styles.footerLink}>
                        Learn more about our privacy policy
                    </a>
                </footer>
            </main>
        </div>
    );
}
